import { type JSX, memo } from 'react';

import type { Bet, Odd } from '../../types';

import { OddsGridCell } from './OddsCell';

interface SportsbookOddsCellProps {
  bet: Bet;
  bookieCode: string;
  isBest: boolean;
  odds: Odd | undefined;
  oddsFormat?: string;
  oddsText: string | number | undefined;
}

const SportsbookOddsCellComponent = ({
  bet,
  bookieCode,
  isBest,
  odds,
  oddsFormat,
  oddsText,
}: SportsbookOddsCellProps): JSX.Element => {
  return (
    <OddsGridCell
      bet={bet}
      betName={bet.name}
      bookieCode={bookieCode}
      isBest={isBest}
      odds={odds}
      oddsFormat={oddsFormat}
      oddsText={oddsText}
    />
  );
};

export const SportsbookOddsCell = memo(SportsbookOddsCellComponent);
